module.exports = __webpack_public_path__ + "img/D - 03.833615ff.png";